import React from 'react';
import {
	DATAPOINT_BOOTLOADER_VERSION,
	DATAPOINT_CERTIFICATE_EXPIRATION,
	DATAPOINT_DATA_MATRIX_CODE,
	DATAPOINT_FIRMWARE_VERSION,
	DATAPOINT_GATEWAY,
	DATAPOINT_HARDWARE_REVISION,
	DATAPOINT_IP_ADRESS,
	DATAPOINT_MAC_ADRESS,
	DATAPOINT_OPEN_SSL_VERSION,
	DATAPOINT_OS_VERSION,
	DATAPOINT_PART_NUMBER,
	DATAPOINT_SERIAL_NUMBER,
	DATAPOINT_SUBNET,
	DATAPOINT_WIFI_CHANNEL,
	DATAPOINT_WIFI_SIGNAL_STRENGTH,
	DATAPOINT_WIFI_SSID,
	DATAPOINT_APPLICATION_VERSION,
	DATAPOINT_DESIRED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_JOB_ID,
	DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER,
	DATAPOINT_REPORTED_JOBS_UPDATE_STATUS
} from '../../../../modules/common/consts';
import type {DataPointData} from './types';
import LabelValueField from './LabelValueField';
import {formatDatapointValue} from './utils';
type Props = {
	className?: string;
	dataPointName: string;
	dataPointInfo: DataPointData | null | undefined;
};
const DataPointTranslations: Record<string, any> = {
	[DATAPOINT_BOOTLOADER_VERSION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_BOOTLOADER_VERSION}`,
		defaultValue: 'Bootloader Version'
	},
	[DATAPOINT_CERTIFICATE_EXPIRATION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_CERTIFICATE_EXPIRATION}`,
		defaultValue: 'Certificate expires at'
	},
	[DATAPOINT_DATA_MATRIX_CODE]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_DATA_MATRIX_CODE}`,
		defaultValue: 'Data Matrix Code'
	},
	[DATAPOINT_FIRMWARE_VERSION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_FIRMWARE_VERSION}`,
		defaultValue: 'uC Firmware Version'
	},
	[DATAPOINT_GATEWAY]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_GATEWAY}`,
		defaultValue: 'Gateway'
	},
	[DATAPOINT_HARDWARE_REVISION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_HARDWARE_REVISION}`,
		defaultValue: 'Hardware Revision'
	},
	[DATAPOINT_IP_ADRESS]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_IP_ADRESS}`,
		defaultValue: 'IP Address'
	},
	[DATAPOINT_MAC_ADRESS]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_MAC_ADRESS}`,
		defaultValue: 'MAC'
	},
	[DATAPOINT_OPEN_SSL_VERSION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_OPEN_SSL_VERSION}`,
		defaultValue: 'OpenSSL Version'
	},
	[DATAPOINT_OS_VERSION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_OS_VERSION}`,
		defaultValue: 'OS Version'
	},
	[DATAPOINT_APPLICATION_VERSION]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_APPLICATION_VERSION}`,
		defaultValue: 'Application Version'
	},
	[DATAPOINT_PART_NUMBER]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_PART_NUMBER}`,
		defaultValue: 'Part Number'
	},
	[DATAPOINT_SERIAL_NUMBER]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_SERIAL_NUMBER}`,
		defaultValue: 'Serial Number'
	},
	[DATAPOINT_SUBNET]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_SUBNET}`,
		defaultValue: 'Subnet'
	},
	[DATAPOINT_WIFI_CHANNEL]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_WIFI_CHANNEL}`,
		defaultValue: 'WiFi Channel'
	},
	[DATAPOINT_WIFI_SIGNAL_STRENGTH]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_WIFI_SIGNAL_STRENGTH}`,
		defaultValue: 'WiFi Signal Strength'
	},
	[DATAPOINT_WIFI_SSID]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_WIFI_SSID}`,
		defaultValue: 'WiFi SSID'
	},
	[DATAPOINT_DESIRED_JOBS_JOB_ID]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_DESIRED_JOBS_JOB_ID}`,
		defaultValue: 'Job Id'
	},
	[DATAPOINT_REPORTED_JOBS_JOB_ID]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_REPORTED_JOBS_JOB_ID}`,
		defaultValue: 'Job Id'
	},
	[DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_REPORTED_JOBS_SEQUENCE_NUMBER}`,
		defaultValue: 'Sequence Number'
	},
	[DATAPOINT_REPORTED_JOBS_UPDATE_STATUS]: {
		i18nKey: `rafi.datapoints.${DATAPOINT_REPORTED_JOBS_UPDATE_STATUS}`,
		defaultValue: 'Update Status'
	}
};

const DataPointInfo = ({dataPointName, dataPointInfo, ...rest}: Props) => {
	const value = dataPointInfo ? dataPointInfo.value : '--';
	const label = DataPointTranslations[dataPointName];
	return (
		<LabelValueField label={label} {...rest}>
			{formatDatapointValue(value)}
		</LabelValueField>
	);
};

export default DataPointInfo;
